import React from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Flex,
  Spacer,
  Text,
  Container,
} from "@chakra-ui/react";
import {
  FaHistory,
  FaShoppingBasket,
  FaUser,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Form from "../components/Form";
import History from "../components/History";
import Register from "../components/Register";
import FieldLogPage from "../components/FieldVisit";
const Home = () => {
  return (
    <Container maxW="container.lg" px={[2, 4, 6]}>
      <Tabs
        isFitted
        defaultValue="sourcing"
        colorScheme="teal"
        variant="enclosed-colored"
        mt="2"
      >
        <TabList w="100%" overflowX="auto" whiteSpace="nowrap">
          <Tab outline="none" value="sourcing">
            <Flex alignItems="center" gap="2" px="2">
              <FaShoppingBasket />
              <Text px="2" fontSize={["sm", "md"]}>
                <b>Sourcing</b>
              </Text>
            </Flex>
          </Tab>
          <Tab value="register">
            <Flex alignItems="center" gap="2" px="2">
              <FaUser />
              <Spacer />
              <Text px="2" fontSize={["sm", "md"]}>
                <b>Register New Supplier</b>
              </Text>
            </Flex>
          </Tab>
          <Tab value="field-visit">
            <Flex alignItems="center" gap="2" px="2">
              <FaMapMarkerAlt />
              <Spacer />
              <Text px="2" fontSize={["sm", "md"]}>
                <b>Record field visit</b>
              </Text>
            </Flex>
          </Tab>
          <Tab value="history">
            <Flex alignItems="center" gap="2" px="2">
              <FaHistory />
              <Spacer />
              <Text px="2" fontSize={["sm", "md"]}>
                <b>History</b>
              </Text>
            </Flex>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel value="sourcing">
            <Form />
          </TabPanel>
          <TabPanel value="register">
            <Register />
          </TabPanel>
          <TabPanel value="field-visit">
            <FieldLogPage />
          </TabPanel>

          <TabPanel value="history">
            <History />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default Home;
